import React from "react";
import Link from "next/link";
import { CardTitle, SpotlightCard, CardDescription, ButtonToProfile } from "shared/Slider/styled";
import { CardImage, CardBody } from "styles/MainCards.styled";
import { Icon } from "components/SvgIcons";
import { NoImage } from "styles/App.styled";
import cloudfront from "../../../helpers/cloudfront";
import { getImageName } from "../../../helpers";

const TemplateForSpotlight = ({ item, context }) => {
  const { description, user, main_image } = item;

  return (
    <SpotlightCard>
      <CardImage>
        <Link href={user.slug || `/${context}/${user.id}`} passHref>
          <a>
            {main_image ? (
              <img
                src={cloudfront({ href: main_image, size: "large" })}
                alt={getImageName(main_image)}
                style={{ left: "0", top: "0" }}
              />
            ) : (
              <NoImage />
            )}
          </a>
        </Link>
      </CardImage>
      <CardBody>
        <Link href={user.slug || `/${context}/${user.id}`} passHref>
          <CardTitle className="spotlight">
            {user?.first_name} {user?.last_name}
          </CardTitle>
        </Link>
        <CardDescription>{description}</CardDescription>
        <Link href={user.slug || `/${context}/${user.id}`} passHref>
          <ButtonToProfile>
            View Profile
            <Icon icon="arrow_right" />
          </ButtonToProfile>
        </Link>
      </CardBody>
    </SpotlightCard>
  );
};

export default TemplateForSpotlight;
